export default {
    eventCategories:        { method: 'get',    url: 'event_categories' },
    createEventCategory:    { method: 'post',   url: 'event_categories'},
    updateEventCategory:    { method: 'put',    url: 'event_categories/{id}'},
    deleteEventCategory:    { method: 'delete', url: 'event_categories/{id}'}
}